import { observer } from 'mobx-react-lite';
import { MilesListContainer, MileListItem, MileNameSection } from './styles';
import {
  FirstMile,
  LastMile,
} from '../../../../models/delivery-options/delivery-miles';
import { getDefaultMile } from '../../../../routes/parcel-delivery/helpers';
import { useStore } from '../../../../stores/store';
import { getSetting } from '../../../../utils/countries/countries.utils';
import { getFormattedPrice } from '../../../../utils/price/get-formatted-price';
import { testIds } from '../../../../../test-ids';
import {
  MileCarrierInfo,
  MileCarrierInfoPart,
} from '../parcel-delivery-option.styles';
import Image from '../../../../common/image-component/image.component';

interface Props {
  selectedMile: FirstMile | LastMile;
  miles: (FirstMile | LastMile)[];
  currencySymbol: string;
  onMileClick?: () => void;
  onMileSelected?: (mile: FirstMile | LastMile) => void;
}

function getPriceDiffString(priceDiff: number, currencySymbol: string) {
  if (priceDiff === 0) return '';
  return `(${priceDiff > 0 ? '+' : '-'} ${getFormattedPrice(priceDiff, currencySymbol)})`;
}

const MilesList = ({
  selectedMile,
  miles,
  currencySymbol,
  onMileClick,
  onMileSelected,
}: Props) => {
  const {
    parcelCreationStore: { countryDeparture },
  } = useStore();

  const basePrice =
    getDefaultMile(
      miles,
      getSetting(
        countryDeparture?.code,
        'delivery_options',
        'delivery_options_default'
      )
    )?.price ?? 0;

  return (
    <MilesListContainer
      data-testid={testIds.parceCreation.deliveryOptions.lastMilesMenu}>
      {miles
        .toSorted((a, b) => a.price - b.price)
        .map((x) => {
          const isMileSelected = selectedMile.uiKey === x.uiKey;
          return (
            <MileListItem
              data-testid={testIds.parceCreation.deliveryOptions.mileOption}
              $selected={isMileSelected}
              onClick={(e) => {
                e.stopPropagation();
                onMileClick?.();
                if (isMileSelected) return;
                onMileSelected?.(x);
              }}
              key={x.uiKey}>
              <Image
                src={x.logo}
                alt={x?.carrier.name ?? ''}
                height='4rem'
                width='4rem'
                borderRadius='10px'
              />
              <MileNameSection $selected={isMileSelected}>
                <span className='service-name-and-price-diff'>
                  <p>{x?.service?.name}</p>
                  <p>
                    {getPriceDiffString(x.price - basePrice, currencySymbol)}
                  </p>
                </span>
                <MileCarrierInfo>
                  <MileCarrierInfoPart>{x?.carrier.name}</MileCarrierInfoPart>
                  {x?.delivery_service?.name && (
                    <MileCarrierInfoPart>
                      ({x?.delivery_service?.name})
                    </MileCarrierInfoPart>
                  )}
                </MileCarrierInfo>
              </MileNameSection>
            </MileListItem>
          );
        })}
    </MilesListContainer>
  );
};

export default observer(MilesList);
